export const APP_LOAD = 'APP_LOAD';
export const REDIRECT = 'REDIRECT';
export const DASHBOARD_PAGE_LOADED = 'DASHBOARD_PAGE_LOADED';
export const DASHBOARD_PAGE_UNLOADED = 'DASHBOARD_PAGE_UNLOADED';
export const SET_PAGE = 'SET_PAGE';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';
export const UPDATE_FIELD_AUTH = 'UPDATE_FIELD_AUTH';
export const DASHBOARD_SLIDER_PAGE_LOADED = 'DASHBOARD_SLIDER_PAGE_LOADED';
export const DASHBOARD_SLIDER_PAGE_UNLOADED = 'DASHBOARD_SLIDER_PAGE_UNLOADED'
export const NOTIFICATION = 'NOTIFICATION'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js